import React, { Fragment } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { ToolbarButton, Toolbar, ToolbarButtonGroup, ToolbarInput } from 'neon-design-system';

export interface AdminListToolbarButton {
	selected: boolean;
	onClick: () => void;
	label: string;
}

export interface AdminListToolbarProps<T> {
	filterItems?: AdminListToolbarButton[];
	searchString: string;
	toolbarPlaceholder: string;
	onQueryStringChange: (value: string) => void;
}

const useStyles = makeStyles((theme: Theme) => createStyles({
	headingCaption: {
		display: 'flex',
		justifyContent: 'space-between',
		'& > div, & > div > div': {
			width: ({isNoFilterItems}: any) => isNoFilterItems ? '100%' : 'auto'
		}
	},
	search: {
		background: theme.palette.error.main,
		width: '100%'
	}
}));

const AdminListToolbar = <T extends object>({filterItems, onQueryStringChange, toolbarPlaceholder, searchString}: AdminListToolbarProps<T>): JSX.Element => {
	const isNoFilterItems = !filterItems;
	const classes = useStyles({isNoFilterItems});

	return (
		<Fragment>
			<Toolbar
				id={'admin-list-toolbar'}
				className={classes.headingCaption}>
				{filterItems ?
					<ToolbarButtonGroup>
						{filterItems.map((item: AdminListToolbarButton, i: number) => {
							return <span key={i}>
								<ToolbarButton
									text={item.label}
									selected={item.selected}
									onClick={item.onClick}/>
							</span>;
						})}
					</ToolbarButtonGroup>
					: <></>
				}
				<ToolbarButtonGroup>
					<ToolbarInput
						id={'admin-list-search-input'}
						icon={'search'}
						autoComplete={'off'}
						fullWidth={isNoFilterItems}
						placeholder={toolbarPlaceholder}
						value={searchString}
						onChange={(value: string): void => {
							onQueryStringChange(value);
						}}/>
				</ToolbarButtonGroup>
			</Toolbar>
		</Fragment>
	);
};

export default AdminListToolbar;
